
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798f8f","stroke-linecap":"round"}},[_c('path',{staticClass:"i-stroke",attrs:{"d":"M6.5 15.5h-2a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5m-7 4h1m-1-4h4m-4-3h4"}}),_c('path',{staticClass:"i-stroke_2",attrs:{"stroke-linejoin":"round","d":"m9 16 2.261-.503L15 11.767c.554-.554.608-1.4.12-1.887-.487-.488-1.331-.434-1.886.12l-3.731 3.737z"}})])])
          )
        }
      }
    